<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue'
import type { IEquippedItems, IItemReward } from '@/types'
import { EItemRewardType } from '@/types'

const props = defineProps<Props>()

const Avatar = defineAsyncComponent(() => import('@/components/game/Avatar.vue'))

interface Props {
	equipped: IEquippedItems
	preview?: IItemReward<any>
	size?: number
	subBg?: string
}

function getAvatarData<T>(type: EItemRewardType, equippedData: T): T {
	if (props.preview?.type === type) {
		return props.preview.data
	}
	return equippedData
}

function getAnimationData() {
	const animationData = getAvatarData(EItemRewardType.Animation, props.equipped.animation.data)
	return animationData[0]
}

function getCurveData() {
	const curveData = getAvatarData(EItemRewardType.Animation, props.equipped.animation.data)
	return curveData[1]
}

const assets = ref<string>(import.meta.env.VITE_STATIC_ASSETS)
</script>

<template>
	<Avatar
		v-if="props.equipped && Object.keys(props.equipped).length === 4"
		:size="props.size"
		:sub-bg="props.subBg"
		:src="`${assets}image/${getAvatarData(EItemRewardType.ProfilePic, props.equipped.profile_pic.data)}`"
		:animation="getAnimationData()"
		:color="getAvatarData(EItemRewardType.Color, props.equipped.color.data)"
		:frame="getAvatarData(EItemRewardType.Style, props.equipped.style.data)"
		:curve="getCurveData()"
	/>
	<div v-else>
		Not Found
	</div>
</template>
